
const Index = () => {
  return (
    <>
      <title>API Engagement - Conditions Générales d’Utilisation</title>
      <div className="mx-auto my-14 w-full max-w-[1200px] flex-1 space-y-10 px-4 sm:w-4/5 sm:px-0">
        <h1 className="mb-2 text-4xl font-bold">Conditions Générales d’Utilisation</h1>

        <div className="space-y-10 border bg-white px-4 py-12 text-base sm:px-24">
          <p>En vigueur à partir du 20/03/2025</p>
          <div className="space-y-6">
            <h2 className="text-lg font-bold">Article 1 - Champ d’application</h2>
            <p>
              Les présentes conditions générales d’utilisation (ci-après « CGU ») précisent le cadre juridique de “API Engagement” (ci-après la “Plateforme”) et définissent les
              conditions d’accès et d’utilisation des Services par l’Utilisateur.
            </p>
          </div>
          <div className="space-y-6">
            <h2 className="text-lg font-bold">Article 2 - Objet de la Plateforme</h2>
            <p>
              <b>La Plateforme</b> est un dispositif mis en œuvre par la Direction de la jeunesse, de l'éducation populaire et de la vie associative (DJEPVA) au sein du ministère
              des Sports, de la Jeunesse et de la Vie associative. L’API Engagement permet aux plateformes d’engagement de mettre en commun leurs missions de bénévolat et de
              volontariat, dans le but d’accroître leur visibilité.
            </p>
          </div>
          <div className="space-y-6">
            <h2 className="text-lg font-bold">Article 3 - Définitions</h2>
            <p>“Éditeur” désigne la personne morale qui met à la disposition du public la Plateforme, à savoir la DJEPVA</p>
            <p>
              “Partenaire” désigne tout acteur privé ou public qui diffuse des missions de bénévolat ou de volontariat, signataire d’une convention de partenariat pour utiliser la
              Plateforme.
            </p>
            <p>
              “Plateforme” désigne le service numérique qui permet aux plateformes d’engagement d’accroître leur visibilité en mettant en commun leurs missions de bénévolat et de
              volontariat.
            </p>
            <p>“Services” désignent les fonctionnalités mises en place par la Plateforme pour répondre à ses finalités.</p>
            <p>“Utilisateur” désigne toute personne physique, membre habilité d’une plateforme d’engagement, qui s’inscrit sur la Plateforme.</p>
          </div>
          <div className="space-y-6">
            <h2 className="text-lg font-bold">Article 4 - Fonctionnalités de la Plateforme</h2>
            <p>Chaque Utilisateur peut :</p>
            <ul className="list-inside list-disc">
              <li>Paramétrer et suivre la performance des flux de missions diffusées ; </li>
              <li>Suivre la performance des impressions, redirections, création de compte et candidatures effectuées par le biais de la Plateforme ; </li>
              <li>Paramétrer des widgets en vue de multidiffuser des missions sur des sites tiers ;</li>
              <li>Mettre en place des liens de suivi pour communiquer sur des missions spécifiques et suivre la performance de ces communications ; </li>
              <li>Gérer les paramètres du compte Partenaire ; </li>
              <li>Gérer les Utilisateurs rattachés au compte d’un Partenaire.</li>
            </ul>
          </div>
          <div className="space-y-6">
            <h2 className="text-lg font-bold">Article 5 - Responsabilités</h2>
            <div className="space-y-4">
              <h3 className="text-base font-semibold">5.1 Responsabilités de l’Éditeur</h3>
              <p>Les sources des informations diffusées sur la Plateforme sont réputées fiables mais elle ne garantit pas être exempte de défauts, d’erreurs ou d’omissions.</p>
              <p>
                L’Éditeur s’engage à la sécurisation de la Plateforme, notamment en prenant toutes les mesures nécessaires permettant de garantir la sécurité et la confidentialité
                des informations fournies. Il ne saurait être tenu responsable de tout contenu publié par l’Utilisateur sur la Plateforme ou sur des sites tiers en lien avec les
                missions de bénévolat et de volontariat.{" "}
              </p>
              <p>
                L’Éditeur fournit les moyens nécessaires et raisonnables pour assurer un accès continu à la Plateforme. Il se réserve le droit de faire évoluer, de modifier ou de
                suspendre, sans préavis, la Plateforme pour des raisons de maintenance ou pour tout autre motif jugé nécessaire.{" "}
              </p>
              <p>
                En cas de manquement à une ou plusieurs des stipulations des présentes CGU, l’Éditeur se réserve le droit de suspendre ou de supprimer le compte de l’Utilisateur
                responsable.
              </p>
              <p>
                L’Éditeur réalise un contrôle à priori des missions de bénévolat et de volontariat proposées par l’Utilisateur, dans le but de garantir notamment la qualité du
                contenu diffusé.{" "}
              </p>
            </div>
            <div className="space-y-4">
              <h3 className="text-base font-semibold">5.2 Responsabilités de l’Utilisateur</h3>
              <p>
                L’Utilisateur s’assure de garder son mot de passe secret. Toute divulgation du mot de passe, quelle que soit sa forme, est interdite. Il assume les risques liés à
                l’utilisation de son adresse courriel et de son mot de passe. Chaque Utilisateur est également responsable de la clé API fournie par l’Éditeur.
              </p>
              <p>
                En créant un compte sur la Plateforme, l’Utilisateur certifie notamment qu’il ne diffuse pas de missions donnant lieu à rémunération ou n’ayant pas de lien avec le
                bénévolat ou le volontariat. L’Utilisateur est seul responsable de tout contenu qu’il renseigne sur la Plateforme.{" "}
              </p>
              <p>
                Il est rappelé que toute personne procédant à une fausse déclaration pour elle-même ou ou pour autrui s’expose notamment aux sanctions prévues à l’article 4 -41-1
                du code pénal.{" "}
              </p>
              <p>
                L’Utilisateur s’engage à ne pas mettre en ligne de contenus ou informations contraires au cadre juridique en vigueur. Il veille notamment à ne pas communiquer de
                données sensibles ou de secrets protégés par la loi, et à ne pas publier de contenus illicites notamment dans les zones de champs libres.
              </p>
            </div>
          </div>
          <div className="space-y-6">
            <h2 className="text-lg font-bold">Article 6 - Propriété intellectuelle</h2>
            <p>
              Les données mises à disposition sur la Plateforme sont sous licence ouverte 2.0. L’usage commercial de la réutilisation des données mises à disposition par la
              Plateforme est autorisé. Toutefois, compte tenu de l’absence de garantie de fiabilité de ces données et de disponibilité de l’API, un tel usage est de la seule
              responsabilité de l’Utilisateur. L’Éditeur ne peut en aucun cas être tenu responsable de tout dommage subi par l’Utilisateur ou un tiers s’agissant des données issues
              de la Plateforme.
            </p>
          </div>
          <div className="space-y-6">
            <h2 className="text-lg font-bold">Article 7 - Mise à jour des conditions générales d’utilisation</h2>
            <p>
              Les termes des présentes CGU peuvent être amendés à tout moment, sans préavis, en fonction des modifications apportées à la Plateforme, de l’évolution de la
              législation ou pour tout autre motif jugé nécessaire. Chaque modification donne lieu à une nouvelle version qui est acceptée par l’Utilisateur.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
